export default "__VITE_ASSET__C7ZGwe8W__"